// 重庆市建委配置信息
const CQ2 = {
    // 参建单位类型
    // inviteList: {
    //     '11': '建设单位',
    //     '14': '监理单位',
    //     '13': '施工单位',
    //     '15': '勘察单位',
    //     '10': '质量检测机构',
    //     '16': '设计单位',
    //     '20': '园林单位',
    //     '21': '城乡规划',
    //     '7': '自然人',
    //     '17': '测绘单位',
    //     '51': '施工单位（分）',
    //     '30': '审图机构',
    //     '18': '招标代理',
    //     '22': '房地产估价',
    //     '27': '物业服务',
    //     '23': '其它单位',
    //     '50': '施工单位（总）',
    //     '42': '造价咨询'
    // },
    inviteList: {
        '001': '专业分包',
        '002': '设备分包',
        '003': '材料分包',
        '004': '后勤服务',
        '005': '特殊设备',
        '006': '劳务分包',
        '007': '监理',
        '008': '建设单位',
        '009': '总承包单位',
        '010': '勘察',
        '011': '设计单位',
        '012': '其它'
    },
    // 银行代码
    bankList: {
        '001': '银联商务（收单）',
        '100': '中国邮政储蓄银行（收单）',
        '102': '中国工商银行',
        '103': '中国农业银行',
        '104': '中国银行',
        '105': '中国建设银行',
        '201': '国家开发银行',
        '202': '中国进出口银行',
        '203': '中国农业发展银行',
        '301': '交通银行',
        '302': '中信银行',
        '303': '中国光大银行',
        '304': '华夏银行',
        '305': '中国民生银行',
        '306': '广东发展银行',
        '307': '深圳发展银行',
        '308': '招商银行',
        '309': '兴业银行',
        '310': '上海浦东发展银行',
        '311': '上海银联商务/东莞商业银行',
        '313': '城市商业银行',
        '314': '农村商业银行（江苏）',
        '315': '恒丰银行',
        '316': '浙商银行',
        '317': '农村合作银行',
        '318': '渤海银行股份有限公司',
        '319': '徽商银行股份有限公司',
        '320': '镇银行有限责任公司',
        '401': '城市信用社',
        '402': '农村信用社（含北京农村商业银行）、东莞农信',
        '403': '中国邮政储蓄银行（代收付）',
        '501': '汇丰银行',
        '502': '东亚银行',
        '503': '南洋商业银行',
        '504': '恒生银行(中国)有限公司',
        '505': '中国银行（香港）有限公司',
        '506': '集友银行有限公司',
        '507': '创兴银行有限公司',
        '509': '星展银行（中国）有限公司',
        '510': '永亨银行（中国）有限公司',
        '512': '永隆银行',
        '531': '花旗银行（中国）有限公司',
        '532': '美国银行有限公司',
        '533': '摩根大通银行(中国)有限公司',
        '561': '三菱东京日联银行(中国）有限公司',
        '563': '日本三井住友银行股份有限公司',
        '564': '瑞穗实业银行（中国）有限公司',
        '565': '日本山口银行股份有限公司',
        '591': '韩国外换银行股份有限公司',
        '593': '友利银行(中国)有限公司',
        '591': '韩国外换银行股份有限公司',
        '593': '友利银行（中国）有限公司',
        '594': '韩国产业银行',
        '595': '新韩银行(中国)有限公司',
        '596': '韩国中小企业银行有限公司',
        '597': '韩亚银行（中国）有限公司',
        '621': '华侨银行（中国）有限公司',
        '622': '大华银行（中国）有限公司',
        '623': '星展银行（中国）有限公司',
        '631': '泰国盘谷银行(大众有限公司)',
        '641': '奥地利中央合作银行股份有限公司',
        '651': '比利时联合银行股份有限公司',
        '652': '比利时富通银行有限公司',
        '661': '荷兰银行',
        '662': '荷兰安智银行股份有限公司',
        '671': '渣打银行',
        '672': '英国苏格兰皇家银行公众有限公司',
        '691': '法国兴业银行（中国)有限公司',
        '694': '法国东方汇理银行股份有限公司',
        '695': '法国外贸银行股份有限公司',
        '711': '德国德累斯登银行股份公司',
        '712': '德意志银行（中国）有限公司',
        '713': '德国商业银行股份有限公司',
        '714': '德国西德银行股份有限公司',
        '715': '德国巴伐利亚州银行',
        '716': '德国北德意志州银行',
        '732': '意大利联合圣保罗银行股份有限公司',
        '741': '瑞士信贷银行股份有限公司',
        '742': '瑞士银行',
        '751': '加拿大丰业银行有限公司',
        '752': '加拿大蒙特利尔银行有限公司',
        '761': '澳大利亚和新西兰银行集团有限公司',
        '771': '摩根士丹利国际银行（中国）有限公司',
        '775': '联合银行(中国)有限公司',
        '776': '荷兰合作银行有限公司',
        '781': '厦门国际银行',
        '782': '法国巴黎银行（中国）有限公司',
        '785': '华商银行',
        '787': '华一银行',
        '897': '广东农村信用合作社（收单）',
        '898': '银联商务（收单）',
        '969': '(澳门地区)银行',
        '989': '(香港地区)银行',
        '9998': '浙江网商银行股份有限公司',
        'SRCB': '深圳农村商业银行',
        'BGB': '广西北部湾银行',
        'SHRCB': '上海农村商业银行',
        'BJBANK': '北京银行',
        'WHCCB': '威海市商业银行',
        'BOZK': '周口银行',
        'KORLABANK': '库尔勒市商业银行',
        'SPABANK': '平安银行',
        'SDEB': '顺德农商银行',
        'HURCB': '湖北省农村信用社',
        'WRCB': '无锡农村商业银行',
        'BOCY': '朝阳银行',
        'HDBANK': '邯郸银行',
        'BOD': '东莞银行',
        'ZYCBANK': '遵义市商业银行',
        'SXCB': '绍兴银行',
        'GZRCU': '贵州省农村信用社',
        'ZJKCCB': '张家口市商业银行',
        'BOJZ': '锦州银行',
        'BOP': '平顶山银行',
        'HKB': '汉口银行',
        'NXRCU': '宁夏黄河农村商业银行',
        'NYNB': '广东南粤银行',
        'GRCB': '广州农商银行',
        'BOSZ': '苏州银行',
        'HZCB': '杭州银行',
        'HSBK': '衡水银行',
        'HBC': '湖北银行',
        'JXBANK': '嘉兴银行',
        'HRXJB': '华融湘江银行',
        'BODD': '丹东银行',
        'AYCB': '安阳银行',
        'TCRCB': '江苏太仓农村商业银行',
        'NJCB': '南京银行',
        'ZZBANK': '郑州银行',
        'DYCB': '德阳商业银行',
        'YBCCB': '宜宾市商业银行',
        'SCRCU': '四川省农村信用',
        'KLB': '昆仑银行',
        'LSBANK': '莱商银行',
        'YDRCB': '尧都农商行',
        'CCQTGB': '重庆三峡银行',
        'FDB': '富滇银行',
        'JSRCU': '江苏省农村信用联合社',
        'JNBANK': '济宁银行',
        'JINCHB': '晋城银行JCBANK',
        'FXCB': '阜新银行',
        'WHRCB': '武汉农村商业银行',
        'HBYCBANK': '湖北银行宜昌分行',
        'TZCB': '台州银行',
        'TACCB': '泰安市商业银行',
        'XCYH': '许昌银行',
        'NXBANK': '宁夏银行',
        'HSBANK': '徽商银行',
        'JJBANK': '九江银行',
        'NHQS': '农信银清算中心',
        'MTBANK': '浙江民泰商业银行',
        'LANGFB': '廊坊银行',
        'ASCB': '鞍山银行',
        'KSRB': '昆山农村商业银行',
        'YXCCB': '玉溪市商业银行',
        'DLB': '大连银行',
        'DRCBCL': '东莞农村商业银行',
        'GCB': '广州银行',
        'NBBANK': '宁波银行',
        'BOYK': '营口银行',
        'SXRCCU': '陕西信合',
        'GLBANK': '桂林银行',
        'BOQH': '青海银行',
        'CDRCB': '成都农商银行',
        'QDCCB': '青岛银行',
        'HBHSBANK': '湖北银行黄石分行',
        'WZCB': '温州银行',
        'TRCB': '天津农商银行',
        'QLBANK': '齐鲁银行',
        'GDRCC': '广东省农村信用社联合社',
        'ZJTLCB': '浙江泰隆商业银行',
        'GZB': '赣州银行',
        'GYCB': '贵阳市商业银行',
        'CQBANK': '重庆银行',
        'DAQINGB': '龙江银行',
        'CGNB': '南充市商业银行',
        'SCCB': '三门峡银行',
        'CSRCB': '常熟农村商业银行',
        'SHBANK': '上海银行',
        'JLBANK': '吉林银行',
        'CZRCB': '常州农村信用联社',
        'BANKWF': '潍坊银行',
        'ZRCBANK': '张家港农村商业银行',
        'FJHXBC': '福建海峡银行',
        'ZJNX': '浙江省农村信用社联合社',
        'LZYH': '兰州银行',
        'JSB': '晋商银行',
        'BOHAIB': '渤海银行',
        'CZCB': '浙江稠州商业银行',
        'YQCCB': '阳泉银行',
        'SJBANK': '盛京银行',
        'XABANK': '西安银行',
        'BSB': '包商银行',
        'JSBANK': '江苏银行',
        'FSCB': '抚顺银行',
        'HNRCU': '河南省农村信用',
        'XTB': '邢台银行',
        'HNRCC': '湖南省农村信用社',
        'DYCCB': '东营市商业银行',
        'ORBANK': '鄂尔多斯银行',
        'BJRCB': '北京农村商业银行',
        'XYBANK': '信阳银行',
        'ZGCCB': '自贡市商业银行',
        'CDCB': '成都银行',
        'HANABANK': '韩亚银行',
        'LYBANK': '洛阳银行',
        'ZBCB': '齐商银行',
        'CBKF': '开封市商业银行',
        'H3CB': '内蒙古银行',
        'CRCBANK': '重庆农村商业银行',
        'SZSBK': '石嘴山银行',
        'DZBANK': '德州银行',
        'SRBANK': '上饶银行',
        'LSCCB': '乐山市商业银行',
        'JXRCU': '江西省农村信用',
        'JZBANK': '晋中市商业银行',
        'HZCCB': '湖州市商业银行',
        'NHB': '南海农村信用联社',
        'XXBANK': '新乡银行',
        'JRCB': '江苏江阴农村商业银行',
        'YNRCC': '云南省农村信用社',
        'GXRCU': '广西省农村信用',
        'PSBC': '中国邮政储蓄银行',
        'BZMD': '驻马店银行',
        'ARCU': '安徽省农村信用社',
        'GSRCU': '甘肃省农村信用',
        'LYCB': '辽阳市商业银行',
        'JLRCU': '吉林农信',
        'URMQCCB': '乌鲁木齐市商业银行',
        'XLBANK': '中山小榄村镇银行',
        'CSCB': '长沙银行',
        'JHBANK': '金华银行',
        'BHB': '河北银行',
        'NBYZ': '鄞州银行',
        'LSBC': '临商银行',
        'BOCD': '承德银行',
        'SDRCU': '山东农信',
        'NCB': '南昌银行',
        'TCCB': '天津银行',
        'WJRCB': '吴江农商银行',
        'CBBQS': '城市商业银行资金清算中心',
        'HBRCU': '河北省农村信用社',
        '9997': '支付宝',
        '000': '其他'
    },
    //管理岗位
    manageTypeList: {
        '007': [{
                id: "1001",
                value: "1001",
                name: "总监理工程师"
            },
            {
                id: "1002",
                value: "1002",
                name: "副总监理工程师"
            },
            {
                id: "1003",
                value: "1003",
                name: "安全监理工程师"
            },
            {
                id: "1004",
                value: "1004",
                name: "专业监理工程师"
            },
            {
                id: "1005",
                value: "1005",
                name: "监理工程师"
            },
            {
                id: "1006",
                value: "1006",
                name: "监理员"
            },
            {
                id: "1007",
                value: "1007",
                name: "监理安全员"
            },
            {
                id: "1024",
                value: "1024",
                name: "总监理工程师代表"
            },
            {
                id: "1099",
                value: "1099",
                name: "其它"
            },
        ],
        '008': [{
                id: "1008",
                value: "1008",
                name: "项目总工程师"
            },
            {
                id: "1009",
                value: "1009",
                name: "项目经理"
            },
            {
                id: "1010",
                value: "1010",
                name: "工程经理"
            },
            {
                id: "1011",
                value: "1011",
                name: "项目技术负责人"
            },
            {
                id: "1012",
                value: "1012",
                name: "项目工程师"
            },
        ],
        '009': [{
                id: "1009",
                value: "1009",
                name: "项目经理"
            },
            {
                id: "1012",
                value: "1012",
                name: "项目工程师"
            },
            {
                id: "1013",
                value: "1013",
                name: "项目管理员"
            },
            {
                id: "1014",
                value: "1014",
                name: "项目副经理"
            },
            {
                id: "1015",
                value: "1015",
                name: "项目总监"
            },
            {
                id: "1016",
                value: "1016",
                name: "施工员"
            },
            {
                id: "1017",
                value: "1017",
                name: "质量员"
            },
            {
                id: "1018",
                value: "1018",
                name: "安全员"
            },
            {
                id: "1019",
                value: "1019",
                name: "标准员"
            },
            {
                id: "1020",
                value: "1020",
                name: "材料员"
            },
            {
                id: "1021",
                value: "1021",
                name: "机械员"
            },
            {
                id: "1022",
                value: "1022",
                name: "劳务员"
            },
            {
                id: "1023",
                value: "1023",
                name: "资料员"
            },
            {
                id: "1025",
                value: "1025",
                name: "测量员"
            },
            {
                id: "1026",
                value: "1026",
                name: "试验员"
            },
            {
                id: "1027",
                value: "1027",
                name: "造价员"
            },
            {
                id: "1028",
                value: "1028",
                name: "质量负责人"
            },
            {
                id: "1029",
                value: "1029",
                name: "安全负责人"
            },
            {
                id: "1030",
                value: "1030",
                name: "技术负责人"
            },
        ],
        'other': [{
                id: "1009",
                value: "1009",
                name: "项目经理"
            },
            {
                id: "1018",
                value: "1018",
                name: "安全员"
            },
            {
                id: "1022",
                value: "1022",
                name: "劳务员"
            },
            {
                id: "1031",
                value: "1031",
                name: "生产经理"
            },
            {
                id: "1032",
                value: "1032",
                name: "物资材料工程师"
            },
            {
                id: "1099",
                value: "1099",
                name: "其它"
            },
        ],
        'all': [{
                id: '1026',
                value: '1026',
                name: '试验员'
            },
            {
                id: '1025',
                value: '1025',
                name: '测量员'
            },
            {
                id: '1019',
                value: '1019',
                name: '标准员'
            },
            {
                id: '1018',
                value: '1018',
                name: '安全员'
            },
            {
                id: '1027',
                value: '1027',
                name: '造价员'
            },
            {
                id: '1024',
                value: '1024',
                name: '总监理工程师代表'
            },
            {
                id: '1012',
                value: '1012',
                name: '项目工程师'
            },
            {
                id: '1011',
                value: '1011',
                name: '项目技术负责人'
            },
            {
                id: '1006',
                value: '1006',
                name: '监理员'
            },
            {
                id: '1013',
                value: '1013',
                name: '项目管理员'
            },
            {
                id: '1021',
                value: '1021',
                name: '机械员'
            },
            {
                id: '1020',
                value: '1020',
                name: '材料员'
            },
            {
                id: '1023',
                value: '1023',
                name: '资料员'
            },
            {
                id: '1022',
                value: '1022',
                name: '劳务员'
            },
            {
                id: '1007',
                value: '1007',
                name: '监理安全员'
            },
            {
                id: '1009',
                value: '1009',
                name: '项目经理'
            },
            {
                id: '1028',
                value: '1028',
                name: '质量负责人'
            },
            {
                id: '1008',
                value: '1008',
                name: '项目总工程师'
            },
            {
                id: '1005',
                value: '1005',
                name: '监理工程师'
            },
            {
                id: '1014',
                value: '1014',
                name: '项目副经理'
            },
            {
                id: '1004',
                value: '1004',
                name: '专业监理工程师'
            },
            {
                id: '1099',
                value: '1099',
                name: '其它'
            },
            {
                id: '1016',
                value: '1016',
                name: '施工员'
            },
            {
                id: '1015',
                value: '1015',
                name: '项目总监'
            },
            {
                id: '1001',
                value: '1001',
                name: '总监理工程师'
            },
            {
                id: '1030',
                value: '1030',
                name: '技术负责人'
            },
            {
                id: '1010',
                value: '1010',
                name: '工程经理'
            },
            {
                id: '1029',
                value: '1029',
                name: '安全负责人'
            },
            {
                id: '1003',
                value: '1003',
                name: '安全监理工程师'
            },
            {
                id: '1032',
                value: '1032',
                name: '物资材料工程师'
            },
            {
                id: '1002',
                value: '1002',
                name: '副总监理工程师'
            },
            {
                id: '1031',
                value: '1031',
                name: '生产经理'
            },
            {
                id: '1017',
                value: '1017',
                name: '质量员'
            },
        ]
    },
    //文化程度
    education: {
        "01": "小学",
        "02": "初中",
        "03": "高中",
        "04": "中专",
        "05": "大专",
        "06": "本科",
        "07": "硕士",
        "08": "博士",
        "99": "其他",
    },
    //学位
    degree: {
        "01": "博士学位",
        "02": "硕士学位",
        "03": "学士学位",
        "04": "无学位",
        "05": "其他",
    },
    //政治面貌
    politicsType: {
        "01": "中共党员",
        "02": "中共预备党员",
        "03": "共青团员",
        "04": "民革党员",
        "05": "民盟盟员",
        "06": "民建会员",
        "07": "民进会员",
        "08": "农工党党员",
        "09": "致公党党员",
        "10": "九三学社社员",
        "11": "台盟盟员",
        "12": "无党派人士",
        "13": "群众",
    },
    // 婚姻状况
    maritalStatus: {
        "01": "未婚",
        "02": "已婚",
        "03": "离异",
        "04": "丧偶",
    },

    // 人员不良行为字典
    badBehavior: {
        "M1-1-1": {
            creditType: "M1-1注册",
            content: "隐瞒有关情况或者提供虚假材料申请注册"
        },
        "M1-1-2": {
            creditType: "M1-1注册",
            content: "以欺骗、贿赂等不正当手段取得注册证书和执业印章"
        },
        "M1-1-3": {
            creditType: "M1-1注册",
            content: "变更聘用单位，未办理变更注册而继续在原单位执业"
        },
        "M1-1-4": {
            creditType: "M1-1注册",
            content: "涂改、倒卖、出租、出借或者以其他形式非法转让执业资格证书、互认资格证书、注册证书和执业印章"
        },
        "M1-2-1": {
            creditType: "M1-2执业",
            content: "超出《中华人民共和国注册建筑师条例实施细则》所规定的执业范围执业"
        },
        "M1-2-2": {
            creditType: "M1-2执业",
            content: "未经注册擅自承担注册建筑师的执业范围业务"
        },
        "M1-2-3": {
            creditType: "M1-2执业",
            content: "未按照法律、法规和工程建设强制性标准进行设计"
        },
        "M1-2-4": {
            creditType: "M1-2执业",
            content: "未受聘并注册于中华人民共和国境内一个具有工程设计资质的单位，从事建筑工程设计执业活动"
        },
        "M1-2-5": {
            creditType: "M1-2执业",
            content: "未根据勘察成果文件进行工程设计,造成质量事故"
        },
        "M1-2-6": {
            creditType: "M1-2执业",
            content: "指定建筑材料、建筑构配件等的生产厂、供应商,造成质量事故"
        },
        "M1-2-7": {
            creditType: "M1-2执业",
            content: "因设计质量不合格发生重大责任事故"
        },
        "M1-2-8": {
            creditType: "M1-2执业",
            content: "以个人名义承接注册建筑师业务、收取费用"
        },
        "M1-2-9": {
            creditType: "M1-2执业",
            content: "准许他人以本人名义执行业务"
        },
        "M1-2-10": {
            creditType: "M1-2执业",
            content: "不保守在执业过程中获悉的单位和个人的秘密"
        },
        "M1-2-11": {
            creditType: "M1-2执业",
            content: "同时在两个以上单位受聘或者执业"
        },
        "M1-2-12": {
            creditType: "M1-2执业",
            content: "施工图审查机构存在违反《房屋建筑和市政基础设施工程施工图设计文件审查管理办法》规定， 被住房城乡建设主管部门给予罚款处罚，为该机构法定代表人或直接责任人员的"
        },
        "M1-2-13": {
            creditType: "M1-2执业",
            content: "在虚假施工图设计文件审查合格书上签字的"
        },
        "M1-3-1": {
            creditType: "M1-3其它",
            content: "未按照要求提供注册建筑师信用档案信息"
        },
        "M1-3-2": {
            creditType: "M1-3其它",
            content: "在注册、执业和继续教育活动中，发生其他违反法律、法规和工程建设强制性标准的行为"
        },
        "N1-1-01": {
            creditType: "N1-1注册",
            content: "隐瞒有关情况或者提供虚假材料申请注册"
        },
        "N1-1-02": {
            creditType: "N1-1注册",
            content: "以欺骗、贿赂等不正当手段取得注册证书的"
        },
        "N1-1-03": {
            creditType: "N1-1注册",
            content: "变更执业单位，未办理变更注册手续"
        },
        "N1-1-04": {
            creditType: "N1-1注册",
            content: "涂改、倒卖、出租、出借或以其他形式非法转让资格证书、注册证书和执业印章"
        },
        "N1-2-01": {
            creditType: "N1-2执业",
            content: "泄露在执业中知悉的国家秘密和他人的商业、技术等秘密"
        },
        "N1-2-02": {
            creditType: "N1-2执业",
            content: "超出《勘察设计注册工程师管理规定》所规定的执业范围"
        },
        "N1-2-03": {
            creditType: "N1-2执业",
            content: "未受聘并注册于中华人民共和国境内一个具有工程设计资质的单位，从事建筑工程设计执业活动"
        },
        "N1-2-04": {
            creditType: "N1-2执业",
            content: "未经注册，擅自以注册建设工程勘察、设计人员的名义从事建设工程勘察、设计活动"
        },
        "N1-2-05": {
            creditType: "N1-2执业",
            content: "同时在两个或两个以上单位受聘或者执业"
        },
        "N1-2-06": {
            creditType: "N1-2执业",
            content: "以个人名义承接业务"
        },
        "N1-2-07": {
            creditType: "N1-2执业",
            content: "未按照法律、法规和工程建设强制性标准进行设计"
        },
        "N1-2-08": {
            creditType: "N1-2执业",
            content: "未对涉及施工安全的重点部位和环节在设计文件中注明，未对防范生产安全事故提出指导意见"
        },
        "N1-2-09": {
            creditType: "N1-2执业",
            content: "采用新结构、新材料、新工艺的建设工程和特殊结构的建设工程，未在设计中提出保障施工作业人员安全和预防生产安全事故的措施建议"
        },
        "N1-2-10": {
            creditType: "N1-2执业",
            content: "未根据勘察成果文件进行工程设计，造成质量事故"
        },
        "N1-2-11": {
            creditType: "N1-2执业",
            content: "指定建筑材料、建筑构配件等的生产厂、供应商，造成质量事故"
        },
        "N1-2-12": {
            creditType: "N1-2执业",
            content: "因设计原因发生重大责任事故"
        },
        "N1-2-13": {
            creditType: "N1-2执业",
            content: "施工图审查机构存在违反《房屋建筑和市政基础设施工程施工图设计文件审查管理办法》规定， 被住房城乡建设主管部门给予罚款处罚，为该机构法定代表人或直接责任人员的"
        },
        "N1-2-14": {
            creditType: "N1-2执业",
            content: "在虚假施工图设计文件审查合格书上签字的"
        },
        "N1-3-01": {
            creditType: "N1-3其它",
            content: "在注册、执业和继续教育活动中，发生其他违反法律、法规和工程建设强制性标准的行为"
        },
        "P1-1-01": {
            creditType: "P1-1注册",
            content: "隐瞒有关情况或者提供虚假材料申请注册"
        },
        "P1-1-02": {
            creditType: "P1-1注册",
            content: "以欺骗、贿赂等不正当手段取得注册证书"
        },
        "P1-1-03": {
            creditType: "P1-1注册",
            content: "涂改、倒卖、出租、出借或以其他形式非法转让资格证书、注册证书和执业印章"
        },
        "P1-1-04": {
            creditType: "P1-1注册",
            content: "未办理变更注册而继续执业"
        },
        "P1-2-01": {
            creditType: "P1-2执业",
            content: "泄露在执业中知悉的国家秘密和他人的商业、技术等秘密"
        },
        "P1-2-02": {
            creditType: "P1-2执业",
            content: "未取得注册证书和执业印章，担任大中型建设工程项目施工单位项目负责人，或者以建造师的名义从事相关活动"
        },
        "P1-2-03": {
            creditType: "P1-2执业",
            content: "同时担任两个及两个以上工程项目负责人"
        },
        "P1-2-04": {
            creditType: "P1-2执业",
            content: "超出执业范围和聘用单位业务范围内从事执业活动"
        },
        "P1-2-05": {
            creditType: "P1-2执业",
            content: "索贿、受贿或者谋取合同约定费用外的其他利益"
        },
        "P1-2-06": {
            creditType: "P1-2执业",
            content: "实施商业贿赂"
        },
        "P1-2-07": {
            creditType: "P1-2执业",
            content: "签署有虚假记载等不合格的文件"
        },
        "P1-2-08": {
            creditType: "P1-2执业",
            content: "允许他人以自己的名义从事执业活动"
        },
        "P1-2-09": {
            creditType: "P1-2执业",
            content: "同时在两个或者两个以上单位受聘或者执业"
        },
        "P1-2-10": {
            creditType: "P1-2执业",
            content: "未按照要求向注册机关提供准确、完整的注册建造师信用档案信息"
        },
        "P1-3-01": {
            creditType: "P1-3其它",
            content: "因过错造成质量事故"
        },
        "P1-3-02": {
            creditType: "P1-3其它",
            content: "未履行安全生产管理职责"
        },
        "P1-3-03": {
            creditType: "P1-3其它",
            content: "违章指挥、强令职工冒险作业，因而发生重大伤亡事故或者造成其他严重后果"
        },
        "P1-3-04": {
            creditType: "P1-3其它",
            content: "在注册、执业和继续教育活动中，发生其他违反法律、法规和工程建设强制性标准的行为"
        },
        "Q1-1-01": {
            creditType: "Q1-1注册",
            content: "隐瞒有关情况或者提供虚假材料申请注册"
        },
        "Q1-1-02": {
            creditType: "Q1-1注册",
            content: "以欺骗、贿赂等不正当手段取得注册证书"
        },
        "Q1-1-03": {
            creditType: "Q1-1注册",
            content: "涂改、倒卖、出租、出借或以其他形式非法转让资格证书、注册证书和执业印章"
        },
        "Q1-1-04": {
            creditType: "Q1-1注册",
            content: "未办理变更注册仍执业"
        },
        "Q1-2-01": {
            creditType: "Q1-2执业",
            content: "泄露在执业中知悉的国家秘密和他人的商业、技术等秘密"
        },
        "Q1-2-02": {
            creditType: "Q1-2执业",
            content: "超出执业范围和聘用单位业务范围内从事执业活动"
        },
        "Q1-2-03": {
            creditType: "Q1-2执业",
            content: "弄虚作假提供执业活动成果"
        },
        "Q1-2-04": {
            creditType: "Q1-2执业",
            content: "以个人名义承接业务"
        },
        "Q1-2-05": {
            creditType: "Q1-2执业",
            content: "将不合格的建设工程、建筑材料、建筑构配件和设备按照合格签字"
        },
        "Q1-2-06": {
            creditType: "Q1-2执业",
            content: "因过错造成质量事故"
        },
        "Q1-3-01": {
            creditType: "Q1-3其它",
            content: "在注册、执业和继续教育活动中，发生其他违反法律、法规和工程建设强制性标准的行为"
        },

    },
}

export default CQ2



// WEBPACK FOOTER //
// ./src/configure/cq2.js